module.exports = __webpack_public_path__ + "img/pt.702eb896.svg";